// 값이 없으면 배차 등록 자체가 불가능한 필드 (New 페이지 validate 기준)
export const REQUIRED_ORDER_FIELDS = [
  "startName",
  "startAddress",
  "startPhoneNumber",
  "startDate",
  "loadTime",
  "endName",
  "endAddress",
  "endPhoneNumber",
  "endDate",
  "unloadTime",
  "productContent",
  "productWeight",
  "carWeight",
  "carType",
  "loadType",
  "unloadType",
];

// 누락 안내 문구 및 확인 배지에 사용
export const ORDER_FIELD_LABELS = {
  startName: "상차지 이름",
  startAddress: "상차지 주소",
  startAddressDetail: "상차지 세부주소",
  startPhoneNumber: "상차지 담당자",
  startDate: "상차 날짜",
  loadTime: "상차 시간",
  endName: "하차지 이름",
  endAddress: "하차지 주소",
  endAddressDetail: "하차지 세부주소",
  endPhoneNumber: "하차지 담당자",
  endDate: "하차 날짜",
  unloadTime: "하차 시간",
  productContent: "화물 내용",
  productWeight: "화물 상차 중량",
  carWeight: "차량 톤수",
  carType: "차종",
  loadType: "상차 방법",
  unloadType: "하차 방법",
  isRoundTrip: "왕복",
  isMixed: "혼적",
  isReceiptRequired: "인수증",
  memo: "기타 요청사항",
};
